var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinePattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1096,
    height: 4,
    viewBox: "0 0 1096 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24755 0.45105L1.71643 0L0 3.63682L2.03805 4L4.24755 0.45105Z",
    fill: "#FF5500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4951 0.45105L25.964 0L24.2476 3.63682L26.2856 4L28.4951 0.45105Z",
    fill: "#FF5500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7427 0.45105L50.2115 0L48.4951 3.63682L50.5332 4L52.7427 0.45105Z",
    fill: "#FF5500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9902 0.45105L74.4591 0L72.7427 3.63682L74.7807 4L76.9902 0.45105Z",
    fill: "#FF5500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.238 0.45105L98.7067 0L96.9902 3.63682L99.0283 4L101.238 0.45105Z",
    fill: "#FF5500"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.485 0.45105L122.954 0L121.238 3.63682L123.276 4L125.485 0.45105Z",
    fill: "#FF5500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.733 0.45105L147.202 0L145.485 3.63682L147.523 4L149.733 0.45105Z",
    fill: "#FF5500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.98 0.45105L171.449 0L169.733 3.63682L171.771 4L173.98 0.45105Z",
    fill: "#FF5500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.228 0.45105L195.697 0L193.98 3.63682L196.019 4L198.228 0.45105Z",
    fill: "#FF5500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.476 0.45105L219.944 0L218.228 3.63682L220.266 4L222.476 0.45105Z",
    fill: "#FF5500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.723 0.45105L244.192 0L242.476 3.63682L244.514 4L246.723 0.45105Z",
    fill: "#FF5500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.971 0.45105L268.44 0L266.723 3.63682L268.761 4L270.971 0.45105Z",
    fill: "#FF5500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M295.218 0.45105L292.687 0L290.971 3.63682L293.009 4L295.218 0.45105Z",
    fill: "#FF5500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M319.466 0.45105L316.935 0L315.218 3.63682L317.256 4L319.466 0.45105Z",
    fill: "#FF5500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.713 0.45105L341.182 0L339.466 3.63682L341.504 4L343.713 0.45105Z",
    fill: "#FF5500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367.961 0.45105L365.43 0L363.713 3.63682L365.751 4L367.961 0.45105Z",
    fill: "#FF5500"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392.208 0.45105L389.677 0L387.961 3.63682L389.999 4L392.208 0.45105Z",
    fill: "#FF5500"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M416.456 0.45105L413.925 0L412.208 3.63682L414.247 4L416.456 0.45105Z",
    fill: "#FF5500"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M440.704 0.45105L438.172 0L436.456 3.63682L438.494 4L440.704 0.45105Z",
    fill: "#FF5500"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M464.951 0.45105L462.42 0L460.704 3.63682L462.742 4L464.951 0.45105Z",
    fill: "#FF5500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M489.199 0.45105L486.668 0L484.951 3.63682L486.989 4L489.199 0.45105Z",
    fill: "#FF5500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M513.446 0.45105L510.915 0L509.199 3.63682L511.237 4L513.446 0.45105Z",
    fill: "#FF5500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M537.694 0.45105L535.163 0L533.446 3.63682L535.484 4L537.694 0.45105Z",
    fill: "#FF5500"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M561.941 0.45105L559.41 0L557.694 3.63682L559.732 4L561.941 0.45105Z",
    fill: "#FF5500"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M586.189 0.45105L583.658 0L581.941 3.63682L583.979 4L586.189 0.45105Z",
    fill: "#FF5500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M610.437 0.45105L607.905 0L606.189 3.63682L608.227 4L610.437 0.45105Z",
    fill: "#FF5500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M634.684 0.45105L632.153 0L630.437 3.63682L632.475 4L634.684 0.45105Z",
    fill: "#FF5500"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M658.932 0.45105L656.401 0L654.684 3.63682L656.722 4L658.932 0.45105Z",
    fill: "#FF5500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M683.179 0.45105L680.648 0L678.932 3.63682L680.97 4L683.179 0.45105Z",
    fill: "#FF5500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M707.427 0.45105L704.896 0L703.179 3.63682L705.217 4L707.427 0.45105Z",
    fill: "#FF5500"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M731.674 0.45105L729.143 0L727.427 3.63682L729.465 4L731.674 0.45105Z",
    fill: "#FF5500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M755.922 0.45105L753.391 0L751.674 3.63682L753.712 4L755.922 0.45105Z",
    fill: "#FF5500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M780.169 0.45105L777.638 0L775.922 3.63682L777.96 4L780.169 0.45105Z",
    fill: "#FF5500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M804.417 0.45105L801.886 0L800.169 3.63682L802.207 4L804.417 0.45105Z",
    fill: "#FF5500"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M828.665 0.45105L826.133 0L824.417 3.63682L826.455 4L828.665 0.45105Z",
    fill: "#FF5500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M852.912 0.45105L850.381 0L848.665 3.63682L850.703 4L852.912 0.45105Z",
    fill: "#FF5500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M877.16 0.45105L874.629 0L872.912 3.63682L874.95 4L877.16 0.45105Z",
    fill: "#FF5500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M901.407 0.45105L898.876 0L897.16 3.63682L899.198 4L901.407 0.45105Z",
    fill: "#FF5500"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M925.655 0.45105L923.124 0L921.407 3.63682L923.445 4L925.655 0.45105Z",
    fill: "#FF5500"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M949.902 0.45105L947.371 0L945.655 3.63682L947.693 4L949.902 0.45105Z",
    fill: "#FF5500"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M974.15 0.45105L971.619 0L969.902 3.63682L971.94 4L974.15 0.45105Z",
    fill: "#FF5500"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M998.397 0.45105L995.866 0L994.15 3.63682L996.188 4L998.397 0.45105Z",
    fill: "#FF5500"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.65 0.45105L1020.11 0L1018.4 3.63682L1020.44 4L1022.65 0.45105Z",
    fill: "#FF5500"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.89 0.45105L1044.36 0L1042.65 3.63682L1044.68 4L1046.89 0.45105Z",
    fill: "#FF5500"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.14 0.45105L1068.61 0L1066.89 3.63682L1068.93 4L1071.14 0.45105Z",
    fill: "#FF5500"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.39 0.45105L1092.86 0L1091.14 3.63682L1093.18 4L1095.39 0.45105Z",
    fill: "#FF5500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePattern);
export default __webpack_public_path__ + "static/media/Line Pattern.2a053e60b92b1e3848561f9920f827e5.svg";
export { ForwardRef as ReactComponent };